import { NotifyHelper } from "../../../helpers/toast";
import { eDoanhNghiepThucTapActionObj } from "../../action-types/category/IDoanhNghiepThucTapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const doanhNghiepThucTapActions = {
    ...generateActions(eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP"),
    ...generateActionForKey(eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eDoanhNghiepThucTapActionObj, "DOANH_NGHIEP_THUC_TAP", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}